import newOrganizeContainer from './newOrganizeContainer';
// import OrganizeModule from './OrganizeContainer';
//import FileMobileModule from './FileContainer.mobile';
import {isMobile} from 'Utils/device';

let OrganizeModuleFn = (isMobile)? null: newOrganizeContainer;

export default OrganizeModuleFn;